import { Component, OnInit, Input, SimpleChange } from '@angular/core';
import { NavController, App, Events } from 'ionic-angular';
import { MessengerProvider } from '../../providers/messenger/messenger';
import { MatchmakingProvider } from './../../providers/matchmaking/matchmaking';
import { GlobalNotificationsProvider } from './../../providers/global-notifications/global-notifications';

/**
 * Generated class for the MessengerPicksComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'messenger-picks',
  templateUrl: 'messenger-picks.html',
})
export class MessengerPicksComponent implements OnInit {
  picks: any[];
  page = 0;
  pageSize = 5;
  totalPages: number = 0;
  keys: any;

  @Input('refresh') refresh;
  @Input('search') search: string = '';

  constructor(
    private app: App,
    private navCtrl: NavController,
    private messengerProvider: MessengerProvider,
    private matchmakingProvider: MatchmakingProvider,
    private globalNotificationsProvider: GlobalNotificationsProvider,
    private events: Events
  ) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChange) {
    if (changes['refresh'] !== undefined || changes['search'] !== undefined) {
      this.page = 0;
      this.getPicks();
    }
  }

  viewProfile(userId: string): void {
    this.app.getRootNav().push('ProfilePage', {
      userId: userId,
    });
  }

  getPicks(): void {
    this.messengerProvider
      .getFavoritesPaginated(this.search, this.page, this.pageSize)
      .subscribe((res: any) => {
        this.keys = Object.keys(res.groupedData);
        this.picks = res.groupedData;
        this.page++;
        this.totalPages = res.totalPages;
      });
  }

  addNote(contact: any): void {
    this.navCtrl.push('NotePage', {
      user: contact,
    });
  }

  removePick(userId: string): void {
    this.matchmakingProvider.removePick(userId).subscribe(res => {
      this.globalNotificationsProvider
        .getRemainingPicks(userId)
        .subscribe(res => {
          this.globalNotificationsProvider.setPicksRemainingCount(res.count);
          this.events.publish('pick');
          this.getPicks();
        });
    });
  }

  doInfinite(infiniteScroll) {
    setTimeout(() => {
      this.messengerProvider
        .getFavoritesPaginated(this.search, this.page, this.pageSize)
        .subscribe(res => {
          const data = res.groupedData;
          this.page++;
          this.totalPages = res.totalPages;
          for (var key in data) {
            if (!this.keys.includes(key)) {
              this.keys.push(key);
              this.picks[key] = [];
            }
            for (let index = 0; index < data[key].length; index++) {
              this.picks[key].push(data[key][index]);
            }
          }
        });

      infiniteScroll.complete();
    }, 1000);
  }
}



// WEBPACK FOOTER //
// ./src/components/messenger-picks/messenger-picks.ts